module.exports = {"Type":"Choice","Disabled":true,"Output":true,"Fields":[{"label":"Text","type":"multiline","name":"text","serializeTo":"q"},{"label":"Options","name":"options"},{"label":"Name of the variable","name":"name","serializeTo":"node"},{"label":"Language Detection","name":"langdet"},{"label":"Bypass current node if variable has value?","type":"yesno","name":"bypass"}],"Header":{"Color":"white","BackgroundColor":"#39a2eb","Text":null}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/Choice.json
// module id = 689
// module chunks = 0